<template>
  <div id="page-eshops-list">

    <!-- BREADCRUMB SECTION -->
    <vs-row class="mb-5" vs-align="center">
      <vs-col vs-w="12">
        <h2 class="breadcrumb">Πηγές</h2>
      </vs-col>
    </vs-row>
    <div class="vx-card p-6">

      <div class="flex flex-wrap items-center">

        <!-- ITEMS PER PAGE -->
        <div class="flex-grow">
          <vs-dropdown vs-trigger-click class="cursor-pointer">
            <div
                class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
              <span class="mr-2">{{
                  currentPage * paginationPageSize - (paginationPageSize - 1)
                }} - {{
                  recordsData.length - currentPage * paginationPageSize > 0 ? currentPage * paginationPageSize : recordsData.length
                }} of {{ recordsData.length }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/>
            </div>
            <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
            <vs-dropdown-menu>

              <vs-dropdown-item @click="gridApi.paginationSetPageSize(10)">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(20)">
                <span>20</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(25)">
                <span>25</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(30)">
                <span>30</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>
      </div>

      <!-- AgGrid Table -->
      <ag-grid-vue ref="agGridTable" :components="components" :gridOptions="gridOptions"
                   class="ag-theme-material w-100 my-4 ag-grid-table" :columnDefs="columnDefs"
                   :defaultColDef="defaultColDef"
                   :rowData="recordsData" rowSelection="multiple" colResizeDefault="shift"
                   :animateRows="true"
                   :floatingFilter="true" :pagination="true" :cacheBlockSize="10"
                   :paginationPageSize="paginationPageSize"
                   @rowDoubleClicked="editItem"
                   :paginationAutoPageSize="true" :filter="true">
      </ag-grid-vue>

    </div>
  </div>
</template>

<script>
import CellRendererStatus from "@/views/cell-renderer-eshops/CellRendererStatus";
import CellRendererActions from "@/views/cell-renderer-eshops/CellRendererActions";
import {AgGridVue} from 'ag-grid-vue'
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'

export default {
  name: "EshopsList",
  components: {
    AgGridVue,
    vSelect,
    flatPickr,
    CellRendererStatus,
    CellRendererActions
  },
  data() {
    return {
      // AgGrid
      gridApi: null,
      gridOptions: {
        floatingFilter: true,
        filter: true,
        pagination: true,
        pivotPanelShow: 'always',
        colResizeDefault: 'shift',
        animateRows: true,
        resizable: true,
      },
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true,
      },
      columnDefs: [
        {
          headerName: 'ID',
          field: 'id',
          width: 125,
          filter: 'agTextColumnFilter',
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: true,
          hide: false
        },
        {
          headerName: 'Όνομα',
          field: 'name',
          filter: 'agTextColumnFilter',
          flex: 1,
          suppressNavigable: true,
          cellClass: 'no-border',
        },
        {
          headerName: 'Σύνδεσμος',
          field: 'url',
          filter: 'agTextColumnFilter',
          flex: 1,
          suppressNavigable: true,
          cellClass: 'no-border',
        },
        {
          headerName: 'Ενεργή',
          field: 'checked',
          filter: 'agTextColumnFilter',
          width: 150,
          cellRendererFramework: 'CellRendererStatus',
          suppressNavigable: true,
          cellClass: 'no-border',
        },
        {
          headerName: '',
          field: 'id',
          width: 120,
          cellRendererFramework: 'CellRendererActions',
          pinned: 'right',
          suppressNavigable: true,
          cellClass: 'no-border',
          filter: false,
        },
      ],

      // Cell Renderer Components
      components: {
        CellRendererStatus,
        CellRendererActions,
      },
    }
  },
  computed: {
    recordsData() {
      return this.$store.getters.getShops
    },
    paginationPageSize() {
      if (this.gridApi) return this.gridApi.paginationGetPageSize()
      else return 10
    },
    totalPages() {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages()
      else return 0
    },
    currentPage: {
      get() {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1
        else return 1
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1)
      },
    }
  },
  methods: {
    editItem(item) {
      this.$router.push("/eshops/edit/" + item.data.id)
    },
  },
  mounted() {
    this.gridApi = this.gridOptions.api
  },
  created() {
    this.$vs.loading()
    this.$store.dispatch('fetchShops').then(() => {
      this.$vs.loading.close()
    })
    this.$vs.loading.close()
  },
}
</script>

<style scoped>

</style>
